module.exports = __webpack_public_path__ + "assets/img/9.b9fb15af.jpg";